export const defaultFormData = {
  name: "",
  locations: {
    sender: true,
    subject: false,
    body: false,
  },
  conditions: [
    {
      type: "contains",
      keywords: [],
      logic: "and",
      isDisabled: 0,
    },
    {
      type: "does_not_contain",
      keywords: [],
      logic: "or",
      isDisabled: 1,
    },
  ],
  actions: "2",
  isDisabled: false,
};

export const labels = {
  RULES_TITLE: "Rules",
  DEFAULT_RULE_SECTION: "Default Rule",
  DEFAULT_RULE_NAME: "Default Rule",
  ADD_RULE: "+ Add Rule",
  ADD_RULE_ONLY: "Add Rule",
  ENABLE_RULE: "Enable",
  DISABLE_RULE: "Disable",
  DELETE_ACTIONS_SECTION: "Deletion Rules",
  OTHER_ACTIONS_SECTION: "Other Rules",
  LOADING_RULES: "Loading rules...",
  CREATED_BY: "Created by:",
  CREATED_BY_UNKNOWN: "N/A",
  NOTIFICATIONS: {
    RULE_UPDATE_SUCCESS: "Rule updated ",
    RULE_UPDATE_FAILURE: "Failed to update rule",
    RULE_ADD_FAILURE: "Failed to add rule",
    RULE_DELETE_SUCCESS: "Rule deleted",
    RULE_DELETE_FAILURE: "Failed to delete rule",
  },
  ACTIONS: {
    CREATE_TASK: "Create task",
    MARK_AS_READ: "Mark as read",
    DELETE_IT: "Delete It",
    ACKNOWLEDGE_TASK: "Acknowledge Task",
  },
  ACTION_TOOLTIPS: {
    CREATE_TASK: "Create Task",
    MARK_AS_READ: "Mark as read",
    DELETE_IT: "Delete It",
    ACKNOWLEDGE_TASK: "Acknowledge Task",
  },
  FORM: {
    TITLE_CREATE: "Create Rule",
    TITLE_EDIT: "Edit Rule",
    STATUS_ACTIVE: "Active",
    STATUS_DISABLED: "Disabled",
    NAME_LABEL: "Name",
    NAME_PLACEHOLDER: "Enter rule name",
    LOCATION_LABEL: "Where to search the text",
    LOCATION_SENDER: "Sender's Address",
    LOCATION_SUBJECT: "Subject",
    LOCATION_BODY: "Body",
    CONDITIONS_LABEL: "Conditions",
    CONDITION_CONTAINS: "Contains",
    CONDITION_NOT_CONTAINS: "Does not contain",
    LOGIC_LABEL: "Logic",
    LOGIC_AND: "And",
    LOGIC_OR: "Or",
    KEYWORDS_PLACEHOLDER: "Enter Keywords & Tags",
    ACTIONS_LABEL: "Actions",
    DELETE_WARNING: "Delete cannot be combined with other actions.",
    CANCEL_BUTTON: "Cancel",
    SAVE_BUTTON: "Save Changes",
    ADD_BUTTON: "Add Rule",
    EDIT_DESCRIPTION: "Edit Description",
  },
  VALIDATION: {
    NAME_REQUIRED: "Name of the rule is required",
    LOCATION_REQUIRED: "At least one location must be selected",
    CONDITION_REQUIRED: "Please select at least one condition",
    KEYWORDS_REQUIRED: "Please enter at least one keyword",
    ACTION_REQUIRED: "Select at least one valid action",
  },
  DEFAULT_RULE_SUBTEXT: "(For emails that don't match any other rules)",
};

export const DELETE_ACTION_ID = 4;
